import { getSIIActivities } from '../services'

export default (country="CHI") => {
  return new Promise((resolve) => {
    getSIIActivities.getSIIActivities(country)
      .then(response => resolve(response.data))
      .catch(err => console.log(err))
  })
}
